import React, { Component } from "react";
import Logo from "../../../components/Logo";
import Checkbox from "../../../components/Checkbox";
import Counter from "../../../components/Counter";
import Radio from "../../../components/Radio";
import Section from "../../../components/Section";
import CriminalLawsuits from "../components/CriminalLawsuits";
import FinancialClaims from "../components/FinancialClaims";
import NonFinancialClaims from "../components/NonFinancialClaims";
import { connect } from "react-redux";
import cloneDeep from "lodash/cloneDeep";
import "./index.css";
import { priceNumbers, setTitle } from "../../../controllers";
import Wrapper from "../../../components/Wrapper";
import Print from "../components/Print";
import Information from "../../../components/Information";
import { Button } from "@material-ui/core";

class Hagholvekaleh extends Component {
  constructor() {
    super();
    this.screens = [
      {
        index: 0,
        label: "دعاوی مالی",
        component: FinancialClaims,
        name: "FinancialClaims",
        requestName: "Mali",
        data: "mali",
      },
      {
        index: 1,
        label: "دعاوی غیر مالی, امور حسبی و خانوادگی",
        component: NonFinancialClaims,
        name: "NonFinancialClaims",
        requestName: "GheyrMali",
        data: "gheyrMali",
      },
      {
        index: 2,
        label: "دعاوی کیفری",
        component: CriminalLawsuits,
        name: "CriminalLawsuits",
        requestName: "Keyfari",
        data: "keyfari",
      },
    ];
    this.state = {
      screen: this.screens[0],
      tarefeYaGharadad: [
        { title: "تعرفه", value: true },
        { title: "قرارداد", value: false },
      ],
      kanoonMatboVakil: [
        { title: "کانون وکلا" },
        { title: "مرکز مشاوران" },
        { title: "نماینده قضایی نهادهای دولتی" },
      ],
      noeVekalat: [
        { title: "تعیینی" },
        { title: "تسخیری" },
        { title: "معاضدتی" },
      ],
    };
  }

  componentDidMount() {
    const { sendData, setMinMax } = this.props;
    sendData(this.state.screen.requestName);
    setMinMax(0);
    setTitle('محاسبه آنلاین حق الوکاله و تمبر مالیاتی وکلا طبق تعرفه و قرارداد')
  }

  // share = () => {
  //   let print = document.getElementsByClassName("Print")[0];
  //   let img = document.createElement("img");
  //   let canvas = document.createElement("canvas");
  //   let a = document.createElement("a");

  //   let src = htmlToJpg(print.innerHTML);
  //   let ctx = canvas.getContext("2d");

  //   canvas.width = 1200;
  //   canvas.height = 900;

  //   img.src = src;
  //   // img.style.display = "none";
  //   ctx.drawImage(img, 0, 0);
  //   a.download = new Date().getTime() + ".png";
  //   a.href = canvas.toDataURL("image/png");
  //   // a.click();
  //   document.body.appendChild(img)
  // };

  componentDidUpdate(prevProps, prevState) {
    const { screen } = this.state;
    const {
      header,
      sendData,
      setMinMax,
      gheyrMali,
      keyfari,
      setHeader,
      setGheyrMali,
      setKeyfari,
    } = cloneDeep(this.props);
    if (prevState.screen.name !== screen.name) {
      setMinMax(this.screens.indexOf(screen));
      sendData(this.state.screen.requestName);
    }
    if (JSON.stringify(header) !== JSON.stringify(prevProps.header)) {
      if (header["tarefeYaGharadad"]) {
        gheyrMali["badvi"] = true;
        keyfari["dadsara"] = true;
        setGheyrMali(gheyrMali);
        setKeyfari(keyfari);
      } else {
        if (header["kanoonMatboVakil"] === 2) {
          header["kanoonMatboVakil"] = 1;
          setHeader(header);
        }
      }
      sendData(this.state.screen.requestName);
    }
    if (
      JSON.stringify(header.noeVekalat) !==
        JSON.stringify(prevProps.header.noeVekalat) ||
      JSON.stringify(header.govahiVekalatTakhasosi) !==
        JSON.stringify(prevProps.header.govahiVekalatTakhasosi)
    ) {
      setMinMax(this.screens.indexOf(screen));
    }
  }

  render() {
    const {
      screen,
      tarefeYaGharadad,
      kanoonMatboVakil,
      noeVekalat,
    } = cloneDeep(this.state);
    const { header, footer, setHeader } = cloneDeep(this.props);
    return (
      <Wrapper>
        <div className="Hagholvekaleh mx-auto pt-3">
          <Logo pageName='محاسبه آنلاین حق الوکاله و تمبر مالیاتی وکلا طبق تعرفه یا قرارداد' />
          <header className="flex column">
            <div className="flex align-center">
              <Section title="محاسبه بر اساس">
                <div className="flex">
                  {tarefeYaGharadad.map((item, index) => (
                    <Radio
                      key={index}
                      title={item.title}
                      value={header["tarefeYaGharadad"] === item.value}
                      setValue={() => {
                        header["tarefeYaGharadad"] = item.value;
                        setHeader(header);
                      }}
                    />
                  ))}
                </div>
              </Section>
              <Section title="کانون متبوع وکیل">
                <div className="flex">
                  {kanoonMatboVakil.map((item, index) => (
                    <Radio
                      value={header["kanoonMatboVakil"] === index}
                      setValue={() => {
                        header["kanoonMatboVakil"] = index;
                        setHeader(header);
                      }}
                      disabled={!header["tarefeYaGharadad"] && index === 2}
                      key={index}
                      title={item.title}
                    />
                  ))}
                </div>
              </Section>
              <Section title="نوع وکالت">
                <div className="flex">
                  {noeVekalat.map((item, index) => (
                    <Radio
                      key={index}
                      title={item.title}
                      value={header["noeVekalat"] === index}
                      setValue={() => {
                        header["noeVekalat"] = index;
                        setHeader(header);
                      }}
                    />
                  ))}
                </div>
              </Section>
              <div className="pr-1">
                <Checkbox
                  value={header["govahiVekalatTakhasosi"]}
                  setValue={() => {
                    header["govahiVekalatTakhasosi"] = !header[
                      "govahiVekalatTakhasosi"
                    ];
                    setHeader(header);
                  }}
                  title="گواهی وکالت تخصصی"
                />
              </div>
            </div>
            <div className="tedad-rozha-mamoriat flex align-center pr-1">
              <div className="mb-2">
                <Counter
                  value={header["mamoryatDakhelOstan"]}
                  setValue={(value) => {
                    header["mamoryatDakhelOstan"] = value;
                    setHeader(header);
                  }}
                  title="روزهای ماموریت داخل استان"
                />
              </div>
              <div className="mb-2">
                <Counter
                  value={header["mamoryatKharejeelOstan"]}
                  setValue={(value) => {
                    header["mamoryatKharejeelOstan"] = value;
                    setHeader(header);
                  }}
                  title="روزهای ماموریت خارج استان"
                />
              </div>
              <div className="pr-1">
                <Checkbox
                  value={header["vekalatPasAzNaghzRay"]}
                  setValue={() => {
                    header["vekalatPasAzNaghzRay"] = !header[
                      "vekalatPasAzNaghzRay"
                    ];
                    setHeader(header);
                  }}
                  title="وکالت پس از نقض رای"
                />
              </div>
            </div>
          </header>
          <nav className="flex align-end">
            {this.screens.map((item, index) => (
              <Button
                key={index}
                className="text-normal"
                color="primary"
                variant={item.name === screen.name ? "contained" : "text"}
                onClick={() => {
                  this.setState({ screen: item });
                }}
              >
                {item.label}
              </Button>
            ))}
          </nav>
          {this.screens.map((item, index) => (
            <main
              key={index}
              style={{ display: screen.name === item.name ? "block" : "none" }}
            >
              {React.createElement(item.component)}
            </main>
          ))}
          <footer className="flex justify-center align-start mt-5 pb-4">
            <div className="flex column flex-center">
              {/* <button className="text-normal full-width mb-2">
                محاسبه بر اساس تعرفه سال 1385
              </button> */}
              {/* <button
                onClick={this.share}
                className="text-normal full-width mb-2"
              >
                اشتراک گذاری
              </button> */}
              <Button
                color="inherit"
                variant="outlined"
                className="text-normal full-width"
                onClick={() => {
                  window.print();
                }}
              >
                چاپ
              </Button>
            </div>
            <div className="flex column flex-center">
              <table className="text-normal">
                <tbody>
                  <tr>
                    <td>جمع کل حق الوکاله</td>
                    <td>{priceNumbers(footer["jameHagholvekalehKol"])} ريال</td>
                  </tr>
                  <tr>
                    <td>هزینه سفر</td>
                    <td>{priceNumbers(footer["hazinehSafar"])} ريال</td>
                  </tr>
                  <tr>
                    <td>جمع هزینه سفر و حق الوکاله</td>
                    <td>
                      {priceNumbers(
                        footer["jameHagholvekalehKol"] + footer["hazinehSafar"]
                      )}{" "}
                      ريال
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="flex column flex-center">
              <table className="text-normal">
                <tbody>
                  <tr>
                    <td>
                      {header["kanoonMatboVakil"] === 2
                        ? "سهم نماینده قضائی"
                        : "حق تمبر مالیاتی"}
                    </td>
                    <td>{priceNumbers(footer["haghTambMaliati"])} ریال</td>
                  </tr>
                  <tr>
                    <td>
                      {header["kanoonMatboVakil"] === 2
                        ? "سهم کارمند موثر در پیشرفت دادرسی "
                        : "سهم صندوق حمایت"}
                    </td>
                    <td>{priceNumbers(footer["sahmSandoghHemayat"])} ريال</td>
                  </tr>
                  {header["kanoonMatboVakil"] !== 2 ? (
                    <tr>
                      <td>سهم هزینه کانون وکلا</td>
                      <td>{priceNumbers(footer["sahmKanoonVokala"])} ريال</td>
                    </tr>
                  ) : null}
                  <tr>
                    <td>
                      {header["kanoonMatboVakil"] === 2
                        ? "جمع سهم کارمندان"
                        : "جمع سهم صندوق حمایت, هزینه کانون و تمبر مالیاتی"}
                    </td>
                    <td>
                      {priceNumbers(
                        footer["haghTambMaliati"] +
                          footer["sahmSandoghHemayat"] +
                          footer["sahmKanoonVokala"]
                      )}{" "}
                      ريال
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </footer>
        <Print type={screen.data} />
        </div>
      </Wrapper>
    );
  }
}

let mapStateToProps = (state) => ({
  header: state.header,
  gheyrMali: state.gheyrMali,
  keyfari: state.keyfari,
  footer: state.footer,
});
let mapDispatchToProps = (dispatch) => ({
  setHeader: (data) => {
    dispatch({ type: "SET_HEADER", data });
  },
  setGheyrMali: (data) => {
    dispatch({ type: "SET_GHEYR_MALI", data });
  },
  setKeyfari: (data) => {
    dispatch({ type: "SET_KEYFARI", data });
  },
  setMinMax: (data) => {
    dispatch({ type: "SET_MINMAX", data });
  },
  sendData: (data) => {
    dispatch({ type: "SEND_DATA", data });
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(Hagholvekaleh);
